import React, { createContext, useContext } from 'react'

interface DashboardContextType {
  refetchJobs: Function | undefined
  refetchTimestamp: Function | undefined
  refetchAggs: Function | undefined
  refetchQcModal: Function | undefined
  refetchAppPreferences: Function | undefined
}

const DashboardContext = createContext({} as DashboardContextType)

export const useDashboardContext = () => useContext(DashboardContext)

export const DashboardReactContextProvider: React.FC<any> = ({ children }) => {
  const initialState = {
    refetchJobs: undefined,
    refetchTimestamp: undefined,
    refetchAggs: undefined,
    refetchQcModal: undefined,
    refetchAppPreferences: undefined,
  }

  return <DashboardContext.Provider value={initialState}>{children}</DashboardContext.Provider>
}
interface AdminContextType {
  refetchQcRsTable: Function | undefined
}

const AdminContext = createContext({} as AdminContextType)

export const useAdminContext = () => useContext(AdminContext)

export const AdminReactContextProvider: React.FC<any> = ({ children }) => {
  const initialState = {
    refetchQcRsTable: undefined,
  }

  return <AdminContext.Provider value={initialState}>{children}</AdminContext.Provider>
}
